import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import { useQuery } from "@apollo/client";

interface IVendorPickerProps {
  handleChange: (stageId: string) => void;
  defaultValue?: string;
  value: string|undefined;
}

export const VendorPicker = ({
  handleChange,
  defaultValue,
  value,
}: IVendorPickerProps) => {
  const data = ['food', 'other']

  return (
    <FormControl fullWidth>
      <InputLabel id="demo-simple-select-label">Vendor Type</InputLabel>
      <Select
        labelId="vendor-type-label"
        id="vendor--type-select"
        value={value}
        label="Vendor Type"
        defaultValue={defaultValue}
        onChange={(event) => handleChange(event.target.value)}
      >
        {data?.map((key) => {
          return <MenuItem value={key}>{key}</MenuItem>;
        })}
      </Select>
    </FormControl>
  );
};
